var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "document-notification" }, [
    _c(
      "div",
      { staticClass: "document-notification__wrapper" },
      [
        _c(
          "div",
          { staticClass: "document-notification__user" },
          [
            _c("c-input-2", {
              class: {
                "is-invalid": _vm.validate && _vm.userError,
              },
              attrs: {
                "floating-label": "Ответственный",
                type: "select",
                items: _vm.usersDictionary,
                searchable: true,
                clearable: true,
              },
              model: {
                value: _vm.notification.user,
                callback: function ($$v) {
                  _vm.$set(_vm.notification, "user", $$v)
                },
                expression: "notification.user",
              },
            }),
            _vm.validate && _vm.userError
              ? _c("div", { staticClass: "feedback-error" }, [
                  _vm._v(" " + _vm._s(_vm.userError) + " "),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c("c-input-2", {
          staticClass: "document-notification__filial",
          attrs: {
            "floating-label": "Филиал",
            type: "select",
            multiple: true,
            items: _vm.filialsDictionary,
            searchable: true,
          },
          model: {
            value: _vm.notification.filials,
            callback: function ($$v) {
              _vm.$set(_vm.notification, "filials", $$v)
            },
            expression: "notification.filials",
          },
        }),
        _c("div", { staticClass: "document-notification__checkboxes" }, [
          _c(
            "div",
            { staticClass: "document-notification__checkbox email" },
            [
              _c("c-switcher", {
                attrs: { type: "checkbox", label: "Email" },
                model: {
                  value: _vm.notification.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.notification, "email", $$v)
                  },
                  expression: "notification.email",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "document-notification__checkbox sms" },
            [
              _c("c-switcher", {
                attrs: { type: "checkbox", label: "SMS" },
                model: {
                  value: _vm.notification.sms,
                  callback: function ($$v) {
                    _vm.$set(_vm.notification, "sms", $$v)
                  },
                  expression: "notification.sms",
                },
              }),
            ],
            1
          ),
        ]),
        _c("c-button-2", {
          directives: [{ name: "b-tooltip", rawName: "v-b-tooltip" }],
          staticClass: "document-notification__remove hidden-sm",
          attrs: {
            size: "iconic",
            title: "Удалить",
            icon: { icon: "trash", color: "secondary" },
          },
          on: {
            click: function ($event) {
              return _vm.$emit("remove")
            },
          },
        }),
        _c("c-button-2", {
          staticClass: "document-notification__remove hidden-md",
          attrs: {
            size: "small",
            label: "Удалить",
            icon: {
              icon: "trash",
              color: "secondary",
            },
          },
          on: {
            click: function ($event) {
              return _vm.$emit("remove")
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }